__webpack_require__.p = "https://static.age.awaze.com/landing-pages-mfe/fd67dcc/_next/";